export default props => {
    return <h2>About</h2>;
}
